module.exports = {
    controller: require('administracao/pagina-destaque/servico/controller-servico-destaque'),
    view: require('administracao/pagina-destaque/servico/view-servico-destaque')
};